module.exports = "//cdn.mxpnl.com/static/asset-cache/dbac67edd8ce3e6558ed9fb29bedbfe5/iron/common/widgets/demo-selector-modal/assets/icons/Finance.svg";